"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.testTcfConfig = exports.prodTcfConfig = void 0;
const mono_scc_1 = require("@snoam/mono-scc");
exports.prodTcfConfig = {
    [mono_scc_1.ClientShortHandName.AB]: {
        baseEndpoint: "https://cmp.aftonbladet.se",
        propertyId: 4595,
        groupPmId: 909888,
        consentLanguage: "sv",
        propertyHref: "https://aftonbladet.se",
    },
    [mono_scc_1.ClientShortHandName.AP]: {
        baseEndpoint: "https://cmp.aftenposten.no",
        propertyId: 4607,
        groupPmId: 1005476,
        consentLanguage: "no",
        propertyHref: "https://aftenposten.no",
    },
    [mono_scc_1.ClientShortHandName.BTI]: {
        baseEndpoint: "https://cmp.bt.no",
        propertyId: 8885,
        groupPmId: 1009108,
        consentLanguage: "no",
        propertyHref: "https://bt.no",
    },
    [mono_scc_1.ClientShortHandName.DP]: {
        baseEndpoint: "https://cmp.vg.no",
        propertyId: 8876,
        groupPmId: 910021,
        consentLanguage: "no",
        propertyHref: "https://vg.no",
    },
    [mono_scc_1.ClientShortHandName.E24]: {
        baseEndpoint: "https://cmp.e24.no",
        propertyId: 16052,
        groupPmId: 894550,
        consentLanguage: "no",
        propertyHref: "https://e24.no",
    },
    [mono_scc_1.ClientShortHandName.SA]: {
        baseEndpoint: "https://cmp.aftenbladet.no",
        propertyId: 8886,
        groupPmId: 1009092,
        consentLanguage: "no",
        propertyHref: "https://www.aftenbladet.no",
    },
    [mono_scc_1.ClientShortHandName.SVD]: {
        baseEndpoint: "https://cmp.svd.se",
        propertyId: 8888,
        groupPmId: 909942,
        consentLanguage: "sv",
        propertyHref: "https://svd.se",
    },
    [mono_scc_1.ClientShortHandName.VG]: {
        baseEndpoint: "https://cmp.vg.no",
        propertyId: 8876,
        groupPmId: 910021,
        consentLanguage: "no",
        propertyHref: "https://vg.no",
    },
    [mono_scc_1.ClientShortHandName.MPL]: {
        baseEndpoint: "https://cmp.magasinpluss.no",
        propertyId: 35128,
        groupPmId: 1049437,
        consentLanguage: "no",
        propertyHref: "https://magasinpluss.no",
    },
};
exports.testTcfConfig = {
    [mono_scc_1.ClientShortHandName.AB]: {
        baseEndpoint: "https://cmp.aftonbladet.se",
        propertyId: 33470,
        groupPmId: 881946,
        consentLanguage: "sv",
        propertyHref: "https://aftonbladet.dev",
    },
    [mono_scc_1.ClientShortHandName.AP]: {
        baseEndpoint: "https://cmp.aftenposten.no",
        propertyId: 15683,
        groupPmId: 1007417,
        consentLanguage: "no",
        propertyHref: "https://stage.aftenposten.no",
    },
    [mono_scc_1.ClientShortHandName.BTI]: {
        baseEndpoint: "https://cmp.bt.no",
        propertyId: 15685,
        groupPmId: 1007440,
        consentLanguage: "no",
        propertyHref: "https://stage.bt.no",
    },
    [mono_scc_1.ClientShortHandName.DP]: {
        baseEndpoint: "https://cmp.vg.no",
        propertyId: 14504,
        groupPmId: 882414,
        consentLanguage: "no",
        propertyHref: "https://stage.vg.no",
    },
    [mono_scc_1.ClientShortHandName.E24]: {
        baseEndpoint: "https://cmp.e24.no",
        propertyId: 14576,
        groupPmId: 879164,
        consentLanguage: "no",
        propertyHref: "https://stage.e24.no",
    },
    [mono_scc_1.ClientShortHandName.SA]: {
        baseEndpoint: "https://cmp.aftenbladet.no",
        propertyId: 15682,
        groupPmId: 1007398,
        consentLanguage: "no",
        propertyHref: "https://www.stage.aftenbladet.no",
    },
    [mono_scc_1.ClientShortHandName.SVD]: {
        baseEndpoint: "https://cmp.svd.se",
        propertyId: 17322,
        groupPmId: 882000,
        consentLanguage: "sv",
        propertyHref: "https://stage.svd.se",
    },
    [mono_scc_1.ClientShortHandName.VG]: {
        baseEndpoint: "https://cmp.vg.no",
        propertyId: 14504,
        groupPmId: 882414,
        consentLanguage: "no",
        propertyHref: "https://stage.vg.no",
    },
    [mono_scc_1.ClientShortHandName.MPL]: {
        baseEndpoint: "https://cmp.magasinpluss.no",
        propertyId: 38027,
        groupPmId: 1224736,
        consentLanguage: "no",
        propertyHref: "https://magasinpluss.no",
    },
};
